/* Favoritos Passalinho — salva no navegador da cliente (localStorage) */
(function () {
  var CHAVE = 'passalinho_favoritos';

  function ler() {
    try {
      var dados = JSON.parse(localStorage.getItem(CHAVE) || '[]');
      return Array.isArray(dados) ? dados : [];
    } catch (e) {
      return [];
    }
  }

  function salvar(lista) {
    try { localStorage.setItem(CHAVE, JSON.stringify(lista)); } catch (e) {}
    atualizarTudo();
    document.dispatchEvent(new CustomEvent('favoritos:alterado', { detail: { lista: lista } }));
  }

  function tem(handle) { return ler().indexOf(handle) !== -1; }

  function alternar(handle) {
    var lista = ler();
    var i = lista.indexOf(handle);
    if (i === -1) { lista.unshift(handle); } else { lista.splice(i, 1); }
    salvar(lista);
    return i === -1;
  }

  function remover(handle) {
    salvar(ler().filter(function (h) { return h !== handle; }));
  }

  /* ---------- Botões de coração ---------- */
  function atualizarBotao(botao) {
    var ativo = tem(botao.getAttribute('data-favorito'));
    botao.classList.toggle('is-ativo', ativo);
    botao.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    var rotulo = ativo ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
    botao.setAttribute('aria-label', rotulo);
    var texto = botao.querySelector('[data-favorito-texto]');
    if (texto) texto.textContent = ativo ? 'Nos seus favoritos' : 'Adicionar aos favoritos';
  }

  function atualizarContadores() {
    var total = ler().length;
    document.querySelectorAll('[data-favoritos-contador]').forEach(function (el) {
      el.textContent = total;
      el.hidden = total === 0;
    });
  }

  function atualizarTudo(raiz) {
    (raiz || document).querySelectorAll('[data-favorito]').forEach(atualizarBotao);
    atualizarContadores();
  }

  document.addEventListener('click', function (evento) {
    var botao = evento.target.closest('[data-favorito]');
    if (!botao) return;
    evento.preventDefault();
    evento.stopPropagation();
    var adicionou = alternar(botao.getAttribute('data-favorito'));
    if (adicionou) {
      botao.classList.remove('is-pulsando');
      void botao.offsetWidth;
      botao.classList.add('is-pulsando');
    }
  }, true);

  /* ---------- Coloca os corações no tema (cards e página do produto) ---------- */
  var ICONE = '<svg class="favorito-botao__icone" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.5-9.3C1.2 8 3.1 4.5 6.6 4.5c2.1 0 3.6 1.2 5.4 3.2 1.8-2 3.3-3.2 5.4-3.2 3.5 0 5.4 3.5 4.1 6.7-2 4.7-9.5 9.3-9.5 9.3z"/></svg>';

  function handleDaUrl(url) {
    var m = /\/products\/([^\/?#]+)/.exec(url || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function criarBotao(handle, estilo) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'favorito-botao favorito-botao--' + estilo;
    b.setAttribute('data-favorito', handle);
    b.innerHTML = ICONE + (estilo === 'pagina' ? '<span data-favorito-texto>Adicionar aos favoritos</span>' : '');
    atualizarBotao(b);
    return b;
  }

  function injetarCards() {
    document.querySelectorAll('product-item .product-item__image-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('[data-favorito]')) return;
      var item = wrapper.closest('product-item');
      /* cards reduzidos (carrinho, "complete o lookinho") ficam sem coração */
      if (item && item.querySelector('.product-item__link')) return;
      var link = wrapper.querySelector('a[href*="/products/"]');
      var handle = link && handleDaUrl(link.getAttribute('href'));
      if (handle) wrapper.appendChild(criarBotao(handle, 'card'));
    });
  }

  function injetarPaginaProduto() {
    var handle = handleDaUrl(location.pathname);
    if (!handle) return;
    var secao = document.querySelector('.shopify-section--main-product');
    if (!secao || secao.querySelector('.favorito-botao--pagina')) return;
    var alvo = secao.querySelector('.product-form__buy-buttons') ||
               secao.querySelector('.product-form__payment-container') ||
               secao.querySelector('.product-form');
    if (!alvo) return;
    var bloco = document.createElement('div');
    bloco.className = 'favorito-pagina-wrapper';
    bloco.appendChild(criarBotao(handle, 'pagina'));
    alvo.parentNode.insertBefore(bloco, alvo.nextSibling);
  }

  function injetar() { injetarCards(); injetarPaginaProduto(); }

  /* O Focal recarrega partes da página (filtros, troca de variante, recomendações).
     Este observador coloca e acende os corações dos produtos que aparecem depois. */
  var agendado = false;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      injetar();
      atualizarTudo();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Mantém abas diferentes sincronizadas */
  window.addEventListener('storage', function (e) {
    if (e.key === CHAVE) { atualizarTudo(); renderizarPagina(); }
  });

  /* ---------- Página "Meus Favoritos" ---------- */
  var formatador = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function dinheiro(centavos) { return formatador.format((centavos || 0) / 100); }

  function imagem(url, largura) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura;
  }

  function escapar(txt) {
    var d = document.createElement('div');
    d.textContent = txt == null ? '' : String(txt);
    return d.innerHTML;
  }

  function cartao(p) {
    var preco = p.price_varies ? 'A partir de ' + dinheiro(p.price_min) : dinheiro(p.price);
    var compare = (!p.price_varies && p.compare_at_price && p.compare_at_price > p.price)
      ? '<span class="favoritos-card__preco-antigo">' + dinheiro(p.compare_at_price) + '</span>' : '';
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = raiz + 'products/' + p.handle;
    var esgotado = !p.available ? '<span class="favoritos-card__esgotado">Esgotado</span>' : '';
    var img = p.featured_image
      ? '<img src="' + imagem(p.featured_image, 600) + '" srcset="' + imagem(p.featured_image, 400) + ' 400w, ' + imagem(p.featured_image, 600) + ' 600w, ' + imagem(p.featured_image, 900) + ' 900w" sizes="(max-width: 740px) 50vw, 25vw" alt="' + escapar(p.title) + '" loading="lazy">'
      : '';

    return '' +
      '<div class="favoritos-card">' +
        '<div class="favoritos-card__imagem">' +
          '<a href="' + url + '">' + img + '</a>' + esgotado +
          '<button type="button" class="favoritos-card__remover" data-favorito-remover="' + escapar(p.handle) + '" aria-label="Remover ' + escapar(p.title) + ' dos favoritos">&times;</button>' +
        '</div>' +
        '<a href="' + url + '" class="favoritos-card__titulo">' + escapar(p.title) + '</a>' +
        '<div class="favoritos-card__preco">' + preco + compare + '</div>' +
        '<a href="' + url + '" class="button button--primary button--small favoritos-card__botao">' + (p.available ? 'Comprar' : 'Ver peça') + '</a>' +
      '</div>';
  }

  function renderizarPagina() {
    var container = document.querySelector('[data-favoritos-lista]');
    if (!container) return;
    var vazio = document.querySelector('[data-favoritos-vazio]');
    var lista = ler();

    if (!lista.length) {
      container.innerHTML = '';
      if (vazio) vazio.hidden = false;
      return;
    }
    if (vazio) vazio.hidden = true;
    container.setAttribute('aria-busy', 'true');

    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(lista.map(function (handle) {
      return fetch(raiz + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (produtos) {
      /* Produtos que saíram da loja são retirados da lista sozinhos */
      var validos = produtos.filter(Boolean);
      if (validos.length !== lista.length) {
        try { localStorage.setItem(CHAVE, JSON.stringify(validos.map(function (p) { return p.handle; }))); } catch (e) {}
        atualizarContadores();
      }
      container.innerHTML = validos.map(cartao).join('');
      container.removeAttribute('aria-busy');
      if (!validos.length && vazio) vazio.hidden = false;
    });
  }

  document.addEventListener('click', function (evento) {
    var botao = evento.target.closest('[data-favorito-remover]');
    if (!botao) return;
    evento.preventDefault();
    var card = botao.closest('.favoritos-card');
    if (card) card.remove();
    remover(botao.getAttribute('data-favorito-remover'));
    if (!ler().length) {
      var vazio = document.querySelector('[data-favoritos-vazio]');
      if (vazio) vazio.hidden = false;
    }
  });

  function iniciar() { injetar(); atualizarTudo(); renderizarPagina(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  window.PassalinhoFavoritos = { ler: ler, alternar: alternar, remover: remover };
})();
